const toUnit = (unit) => (value) => {
    return Number(value) && value !== 0 ? `${value}${unit}` : value;
};
const toPx = toUnit('px');

export { toPx, toUnit };
